import ApiDataTableContainer from "../../../../Components/Tables/DataTables/ApiDataTable/ApiDataTable"

const ApiDataTable = () => {
  return (
    <div className='page-body'>
      <ApiDataTableContainer />
    </div>
  )
}

export default ApiDataTable